module.exports = __webpack_public_path__ + "static/media/data_anchoring_bitcoin-studio.41763637.jpg";